import React from 'react';
import { useParams } from 'react-router-dom';
import { usePartnerDetails } from '../hooks/use-partner-details.js';
import PartnerDetailsPageView from './partner-details-page-view.jsx';

function PartnerDetailsPageContent() {
  const state = usePartnerDetails();
  return <PartnerDetailsPageView {...state} />;
}

function PartnerDetailsPageContainer() {
  const { uid } = useParams();

  return <PartnerDetailsPageContent key={String(uid || '')} />;
}

export default PartnerDetailsPageContainer;
